module.exports = __webpack_public_path__ + "81379ba68c0a77cfef83b3fa40dc0137.png";